import React, {useState, useCallback} from 'react';

import {useI18n} from '@udemy/i18n';
import {Button, Image} from '@udemy/react-core-components';
import {FormattedCurrency} from '@udemy/react-merchandising-components';
import {isAndroidNative, isiOSNative, NativeAppWebviewBridge} from '@udemy/shared-utils';
import {ShoppingClient} from '@udemy/shopping';
import {udLink} from '@udemy/ud-data';

import {getConfig} from 'src/features/cart/config';

import styles from './empty-shopping-list.module.less';
import {OnKeepShoppingMessage} from './events';

export const EmptyCartShoppingList = () => {
    const {gettext, interpolate, ngettext} = useI18n();
    const [webviewBridge] = useState(new NativeAppWebviewBridge());
    const config = getConfig(gettext, interpolate, ngettext);

    const mobileWebviewCallback = useCallback(() => {
        if (
            isAndroidNative() &&
            typeof (globalThis as unknown as {AndroidClient: {onKeepShopping: () => void}})
                .AndroidClient?.onKeepShopping === 'function'
        ) {
            (
                globalThis as unknown as {AndroidClient: {onKeepShopping: () => void}}
            ).AndroidClient.onKeepShopping();
        }
        webviewBridge.sendMessage(new OnKeepShoppingMessage());
    }, [webviewBridge]);

    return (
        <>
            <div className={styles['empty-shopping-list-container']}>
                <Image
                    src={udLink.toStorageStaticAsset(
                        'browse_components/flyout/empty-shopping-cart-v2.jpg',
                    )}
                    srcSet={`${udLink.toStorageStaticAsset(
                        'browse_components/flyout/empty-shopping-cart-v2.jpg',
                    )} 1x, ${udLink.toStorageStaticAsset(
                        'browse_components/flyout/empty-shopping-cart-v2-2x.jpg',
                    )} 2x`}
                    alt=""
                    width={240}
                    height={180}
                    className={styles['empty-cart-img']}
                />
                <p className={styles['empty-shopping-list-message']}>
                    {config.shoppingList.listStrings.empty.cartPage.cart}
                </p>

                {isAndroidNative() || isiOSNative() ? (
                    <Button udStyle="primary" onClick={mobileWebviewCallback}>
                        {gettext('Keep shopping')}
                    </Button>
                ) : (
                    <Button componentClass="a" href={config.urls.keepShopping} udStyle="brand">
                        {gettext('Keep shopping')}
                    </Button>
                )}
            </div>
            {ShoppingClient.credit.amount > 0 && (
                <div className={styles['credit-balance']}>
                    <span>{gettext('Credit balance')}</span>
                    <FormattedCurrency value={ShoppingClient.credit.amount} />
                </div>
            )}
        </>
    );
};
